export default __webpack_public_path__ + "static/media/Gohort.b15262e9.png";